module.exports = __webpack_public_path__ + "img/car_sendai14.78e87291.jpg";